<template>
  <div>
    <div class="wz-page-header">
      <h1 class="wz-page-title">Planillas</h1>
    </div>

    <wz-table-container>

      <wz-table-toolbar>
        <template #left>
          <wz-select :items="companies" v-model="selectedCompanyId" defaultOption="Elegir empresa" />
          <wz-select :items="yearOptions" v-model="selectedYear" defaultOption="Año" />
          <wz-select :items="typeOptions" v-model="filterType" defaultOption="Todos los tipos" />
          <wz-select :items="statusFilterOptions" v-model="filterStatus" defaultOption="Todos los estados" />
        </template>
        <template #right>
          <wz-button variant="primary" @click="$router.push({ name: 'payroll-engine' })">Nueva planilla</wz-button>
        </template>
      </wz-table-toolbar>

      <wz-table>
        <thead>
          <tr>
            <th>Tipo</th>
            <th>Período</th>
            <th>Empresa</th>
            <th style="text-align: right">Colaboradores</th>
            <th style="text-align: right">Total bruto</th>
            <th style="text-align: right">Total neto</th>
            <th>Estado</th>
            <th>Calculada</th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!selectedCompanyId || !selectedYear">
            <td colspan="9" class="text-center text-muted py-4">Seleccione empresa y año para ver las planillas</td>
          </tr>
          <tr v-else-if="filteredList.length === 0">
            <td colspan="9" class="text-center text-muted py-4">No se encontraron planillas</td>
          </tr>
          <tr v-for="p in filteredList" :key="p.id">
            <td class="pl-3">{{ p.payrollTypeName }}</td>
            <td>{{ p.periodYear }}-{{ String(p.periodMonth).padStart(2, '0') }}</td>
            <td>{{ p.companyName }}</td>
            <td style="text-align: right">{{ p.totalEmployees }}</td>
            <td style="text-align: right">{{ formatNumber(p.totalGross) }}</td>
            <td style="text-align: right">{{ formatNumber(p.totalNet) }}</td>
            <td><wz-badge :variant="statusBadge(p.payrollStatus)">{{ p.payrollStatus }}</wz-badge></td>
            <td><span v-local-date="p.calculatedAt"></span></td>
            <td>
              <wz-button size="sm" variant="outline" @click="openDetail(p)">Ver detalle</wz-button>
            </td>
          </tr>
        </tbody>
      </wz-table>

      <wz-table-footer>
        <span>{{ filteredList.length }} planilla(s)</span>
      </wz-table-footer>

    </wz-table-container>
  </div>
</template>

<script>
import { Alert } from "@wizepe/wizeui"
import { CompanyService, PayrollTypeService, PayrollEngineService } from '@/core/services'

export default {
  name: 'PayrollEngineList',
  data() {
    const currentYear = new Date().getFullYear()
    return {
      companies: [],
      payrollTypes: [],
      selectedCompanyId: null,
      selectedYear: currentYear,
      filterType: '',
      filterStatus: '',
      list: [],
      yearOptions: Array.from({ length: 5 }, (_, i) => ({ key: currentYear - i, label: String(currentYear - i) })),
      statusFilterOptions: [
        { key: 'DRAFT',      label: 'Borrador' },
        { key: 'CALCULATED', label: 'Calculada' },
        { key: 'APPROVED',   label: 'Aprobada' },
        { key: 'PAID',       label: 'Pagada' },
        { key: 'ANNULLED',   label: 'Anulada' },
      ],
    }
  },
  computed: {
    typeOptions() {
      return this.payrollTypes.map(t => ({ key: t.key, label: t.label }))
    },
    filteredList() {
      return this.list.filter(p =>
        (!this.filterType || p.payrollTypeId === this.filterType) &&
        (!this.filterStatus || p.payrollStatus === this.filterStatus))
    },
  },
  watch: {
    selectedCompanyId() { this.loadData() },
    selectedYear() { this.loadData() },
  },
  methods: {
    formatNumber(val) {
      if (val == null) return '0.00'
      return Number(val).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    statusBadge(status) {
      const map = {
        DRAFT: 'secondary-solid',
        CALCULATED: 'info-solid',
        APPROVED: 'success-solid',
        PAID: 'success-solid',
        ANNULLED: 'danger-solid',
      }
      return map[status] || 'dark'
    },
    async loadData() {
      if (!this.selectedCompanyId || !this.selectedYear) {
        this.list = []
        return
      }
      try {
        this.$store.dispatch('app/loading', true)
        const resp = await PayrollEngineService.list(this.selectedCompanyId, this.selectedYear)
        this.list = resp.payload || []
      } catch (ex) {
        console.error(ex)
        Alert.error('Error al cargar las planillas')
      } finally {
        this.$store.dispatch('app/loading', false)
      }
    },
    openDetail(p) {
      this.$router.push({ name: 'payroll-engine-detail', params: { id: String(p.id) } })
    },
  },
  async created() {
    try {
      const [companiesResp, typesResp] = await Promise.all([
        CompanyService.listAll(),
        PayrollTypeService.listActive(),
      ])
      this.companies = (companiesResp.payload || []).map(c => ({ key: c.id, label: c.name }))
      this.payrollTypes = (typesResp.payload || []).map(t => ({ key: t.id, label: t.name }))
    } catch (ex) {
      console.error(ex)
      Alert.error('Error al cargar catálogos')
    }
  },
}
</script>

<style lang="stylus" scoped></style>
